module.exports = __webpack_public_path__ + "static/media/1-mai-3.98bb2442.jpg";